// src/pages/dashboard/Dashboard.jsx
import React from 'react';
import { Box } from '@mui/material';
import MyTasksSectioned from '../../components/dashboard/MyTasksSectioned';
import AnalyticsDashboard from '../analytics/Dashboard';
import usePermissionStore from '../../stores/permissionStore';

/**
 * Dashboard component that shows analytics dashboard for super admins
 * and sectioned tasks dashboard for regular users
 */
const Dashboard = () => {
  const { isSuperAdmin } = usePermissionStore();
  
  // Check if user is a super admin
  const isUserSuperAdmin = isSuperAdmin();
  
  return (
    <Box sx={{ 
      height: '100%',
      width: '100%',
      display: 'flex', 
      flexDirection: 'column',
      overflow: 'hidden'  // Container prevents overflow
    }}>
      {isUserSuperAdmin ? (
        // Show analytics dashboard for super admins
        // <AnalyticsDashboard />
                <MyTasksSectioned />

      ) : (
        // Show sectioned tasks dashboard for regular users
        <MyTasksSectioned />
      )}
    </Box>
  );
};

export default Dashboard;